import { Injectable } from '@angular/core';
import { PICKUP } from '@checkout/const';
import { CheckoutActions } from '@checkout/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Pos } from '@shop/const';
import { ShopActions } from '@shop/data-access';
import { Observable } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { PickupService } from '../services';

@Injectable()
export class ShopsEffects {
  loadShopsListSuccess$: Observable<CheckoutActions.ResetShop> = createEffect(() =>
    this.actions$
      .pipe(
        ofType(ShopActions.LOAD_SHOPS_LIST_SUCCESS),
        map((action: ShopActions.LoadShopListSuccess) => action.payload),
      )
      .pipe(
        switchMap((shops: Pos[]) =>
          this.pickupService.activeShopId$.pipe(
            take(1),
            filter<string>(Boolean),
            filter((activeShopId: string) => !shops.find((shop: Pos) => shop.name === activeShopId)),
            map(() => new CheckoutActions.ResetShop()),
          ),
        ),
      ),
  );

  reloadShopsListAfterSetReceiptType$: Observable<ShopActions.LoadShopList> = createEffect(() =>
    this.actions$.pipe(
      ofType(CheckoutActions.SET_ACTIVE_RECEIPT_TYPE),
      map((action: CheckoutActions.SetReceiptType) => action.payload),
      filter((type) => type === PICKUP),
      map(() => new ShopActions.LoadShopList()),
    ),
  );

  constructor(
    private actions$: Actions,
    private pickupService: PickupService,
  ) {}
}
